<template>
  <div>
    <el-row type="flex" justify="end" class="desc-table-top">
      <el-button size="small" style="margin-right: 2px;" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </el-row>
    <el-row>
      <el-table-wrapper ref="commonTable" border :data="tableDatas" :columns="columns" :show-custom-header="true" :show-search-tool="showSearchTool" :show-overflow-tooltip="true"
      :pagination="true" :remote="true" :total="tableTotal" :column-default="columnDefault" @condition-change="onChangeTable">
      </el-table-wrapper>
    </el-row>
  </div>
</template>

<script>
import { EMPTY_TEXT, getValueAfterCheckEmpty } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { columnDefault } from '@/constants/table';
import { mapGetters } from 'vuex';
import { getDateToString } from '@/utils/date';
import { isNil } from 'lodash';
import perfApi from '@/api/virtual/performance/config';
import FileApi from '@/api/common/file';
import msgUtil from '@/utils/message';

export default {
  name: 'WCommonConfigTable',
  props: {
    active: {
      type: Boolean,
      defulat: () => false,
    },
  },
  data() {
    return {
      tableDatas: [],
      columnDefault,
      tableTotal: 0,
      showSearchTool: false,
      columns: [
        { label: '관리대상 명', prop: 'objName', remoteProp: 'o.obj_name', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: 'IP', prop: 'ipaddress', remoteProp: 'ipaddress', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '구분', prop: 'objtypeName', remoteProp: 'ot.objtype_name', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '관리자 정', prop: 'objManagerIdMajor', remoteProp: 'o.obj_manager_id_major', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '관리자 부', prop: 'objManagerIdMinor', remoteProp: 'o.obj_manager_id_minor', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '유지보수 업체', prop: 'maintenanceCompany', remoteProp: 'maintenanceCompany', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '중요도', prop: 'objImportance', remoteProp: 'oi.data_integer', sortable: true, searchable: true, formatter: this.getTableValueAfterCheckEmpty },
        { label: '변경감지시각', prop: 'checkDatetime', remoteProp: 'och.check_datetime', searchType: 'date', searchable: true, formatter: this.convertDatetime },
      ],
      EMPTY_TEXT,
    };
  },
  computed: {
    ...mapGetters(['selectedNode', 'selectedVmsObjtypeIds']),
    treeType() {
      return this.$route.path.indexOf('physical') > 0 ? 'physical' : 'logical';
    },
  },
  watch: {
    selectedNode: {
      handler() {
        this.loadStore();
      },
    },
    selectedVmsObjtypeIds: {
      handler() {
        if (this.$refs.commonTable === undefined) {
          this.$nextTick(() => {
            this.loadStore();
          });
        } else {
          this.loadStore();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadStore() {
      if (this.active) {
        const tableParams = this.$refs.commonTable.getParameter();
        const params = {
          ...tableParams,
          treeType: this.treeType,
          subType: this.selectedNode.subType,
          hypervisorType: this.selectedNode.hypervisorType,
          objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
          virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
          objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
          objtypeIds: this.selectedVmsObjtypeIds,
        };
        perfApi.getGroupConfigInfoForCommonObjtype(params).then((response) => {
          if (response.data.success) {
            this.tableDatas = response.data.data;
            this.tableTotal = response.data.total;
          }
        });
      }
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    onChangeTable() {
      this.loadStore();
    },
    convertValue(value) {
      return isNil(value) ? EMPTY_TEXT : convertValuByUnit(value, null);
    },
    convertDatetime(row, column, value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    // 공통 장비 목록 엑셀 출력
    onClickExportExcel() {
      const tableParams = this.$refs.commonTable.getParameter();
      delete tableParams.start;
      delete tableParams.limit;
      const params = {
        ...tableParams,
        treeType: this.treeType,
        subType: this.selectedNode.subType,
        hypervisorType: this.selectedNode.hypervisorType,
        objId: this.selectedNode.obj ? this.selectedNode.obj.objId : null,
        virtualcenterGroupId: this.selectedNode.virtualcenterGroupId,
        objtypeId: this.selectedNode.obj ? this.selectedNode.obj.objtypeId : this.selectedNode.objtypeId,
        objtypeIds: this.selectedVmsObjtypeIds,
      };
      perfApi.exportVmsConfigInfoDeviceList(params)
        .then((response) => {
          if (response.data.success && !isNil(response.data.data)) {
            FileApi.downloadExportedExcelFile(response.data.data);
          } else {
            this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
          }
        })
        .catch(() => {
          this.$message(msgUtil.getResultMsgData('출력', '엑셀', false));
        });
    },
    convertValuByUnit,
  },
};
</script>



// WEBPACK FOOTER //
// src/views/virtual/performance/group/config/components/CommonConfigTable.vue